import * as React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Icon from './Icons';
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem } from 'reactstrap';

import createLogger from '../../utils/createLogger';
import {Button} from "./Elements";

const DEBUG = true;
const debug = createLogger(DEBUG, `static/Elements.js`);

class HeaderNav extends React.Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
  }
  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }


  render() {

    return (
      <div className="navbar">
        <Navbar expand="md" light>
          <NavbarToggler onClick={this.toggle} />
           <Collapse isOpen={this.state.isOpen} navbar>
            <Nav className="ml-auto" navbar>
              <NavItem>
                <NavLink href="/jobs/">Agency Promotions</NavLink>
              </NavItem>
              {/*<NavItem>*/}
              {/*  <NavLink href='/jobs/owp/'>Open Web Promotions</NavLink>*/}
              {/*</NavItem>*/}
              <NavItem>
                <NavLink href="/jobs/agencies/">Agencies</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="/jobs/titles/">Titles</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href="/jobs/openweb/">Scans</NavLink>
              </NavItem>
              <NavItem>
                <NavLink href='/jobs/dashboard/'>Dashboard</NavLink>
              </NavItem>
              {/*<NavItem>*/}
              {/*  <NavLink href="/jobs/leads/">Found Leads</NavLink>*/}
              {/*</NavItem>*/}
            </Nav>
           </Collapse>
        </Navbar>
      </div>
    )
  }
}

export default HeaderNav;


// WEBPACK FOOTER //
// ./src/components/static/HeaderNav.js